import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './config/firebase'; // Initialize Firebase
import Home from './pages/Home';
import CategoryPage from './pages/CategoryPage';
import TagPage from './pages/TagPage';
import AllTags from './pages/AllTags';
import AllCategories from './pages/AllCategories';
import BusinessDetail from './pages/BusinessDetail';
import SubmitBusiness from './pages/SubmitBusiness';
import UserLogin from './pages/UserLogin';
import UserSignup from './pages/UserSignup';
import UserProfile from './pages/UserProfile';
import FavouritesPage from './pages/FavouritesPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminCategories from './pages/admin/AdminCategories';
import AdminBusinesses from './pages/admin/AdminBusinesses';
import AdminRequests from './pages/admin/AdminRequests';
import AdminCities from './pages/admin/AdminCities';
import AdminTags from './pages/admin/AdminTags';
import AdminSubcategories from './pages/admin/AdminSubcategories';
import AdminReviews from './pages/admin/AdminReviews';
import AdminReports from './pages/admin/AdminReports';
import AdminUsers from './pages/admin/AdminUsers';
import AdminContentCategories from './pages/admin/AdminContentCategories';
import AdminContentTags from './pages/admin/AdminContentTags';
import AdminBlogs from './pages/admin/AdminBlogs';
import AdminNews from './pages/admin/AdminNews';
import AdminBloodDonors from './pages/admin/AdminBloodDonors';
import AdminPhoneLogs from './pages/admin/AdminPhoneLogs';
import AdminOfficers from './pages/admin/AdminOfficers';
import AdminBhaviSarpanch from './pages/admin/AdminBhaviSarpanch';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FAQ from './pages/FAQ';
import HowItWorks from './pages/HowItWorks';
import FeaturedBusinesses from './pages/FeaturedBusinesses';
import SearchResults from './pages/SearchResults';
import BloodDonors from './pages/BloodDonors';
import Officers from './pages/Officers';
import BlogListPage from './pages/BlogListPage';
import BlogDetailPage from './pages/BlogDetailPage';
import NewsListPage from './pages/NewsListPage';
import NewsDetailPage from './pages/NewsDetailPage';
import BusTimeTableHub from './pages/BusTimeTableHub';
import BusTimeTableTohanaHub from './pages/BusTimeTableTohanaHub';
import BusTimeTableVillageHub from './pages/BusTimeTableVillageHub';
import BusTimeTableTohanaLocalHub from './pages/BusTimeTableTohanaLocalHub';
import BusTimeTableThroughHub from './pages/BusTimeTableThroughHub';
import BusTimeTableDetail from './pages/BusTimeTableDetail';
import VillagesPage from './pages/VillagesPage';
import VillageDetailPage from './pages/VillageDetailPage';
import BhaviSarpanchPage from './pages/BhaviSarpanchPage';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import SubmitBusinessModal from './components/SubmitBusinessModal';
import BottomNav from './components/BottomNav';
import { AdminEditProvider } from './contexts/AdminEditContext';
import { SubmitBusinessProvider, useSubmitBusiness } from './contexts/SubmitBusinessContext';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const { isOpen, closeModal, openModal } = useSubmitBusiness();

  return (
    <div className="min-h-screen flex flex-col">
      {!isAdminRoute && <Navbar />}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/login" element={<UserLogin />} />
          <Route path="/signup" element={<UserSignup />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/submit-business" element={<SubmitBusiness />} />
          <Route path="/featured" element={<FeaturedBusinesses />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/blood-donors" element={<BloodDonors />} />
          <Route path="/officers" element={<Officers />} />
          <Route path="/tags" element={<AllTags />} />
          <Route path="/categories" element={<AllCategories />} />
          <Route path="/tag/:tagSlug" element={<TagPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/category/:slug" element={<BlogListPage />} />
          <Route path="/blog/tag/:slug" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/news" element={<NewsListPage />} />
          <Route path="/news/category/:slug" element={<NewsListPage />} />
          <Route path="/news/tag/:slug" element={<NewsListPage />} />
          <Route path="/news/:slug" element={<NewsDetailPage />} />
          <Route path="/favourites" element={<FavouritesPage />} />
          <Route path="/bus-time-table" element={<BusTimeTableHub />} />
          <Route path="/bus-time-table/fatehabad" element={<BusTimeTableHub />} />
          <Route path="/bus-time-table/tohana" element={<BusTimeTableTohanaHub />} />
          <Route path="/bus-time-table/fatehabad-village-routes" element={<BusTimeTableVillageHub />} />
          <Route path="/bus-time-table/tohana-local-routes" element={<BusTimeTableTohanaLocalHub />} />
          <Route path="/bus-time-table/through-buses" element={<BusTimeTableThroughHub />} />
          <Route path="/bus-time-table/:routeSlug" element={<BusTimeTableDetail />} />
          <Route path="/villages" element={<VillagesPage />} />
          <Route path="/village/:slug" element={<VillageDetailPage />} />
          <Route path="/bhavi-sarpanch" element={<BhaviSarpanchPage />} />
          <Route path="/:categorySlug/:businessSlug" element={<BusinessDetail />} />
          <Route path="/:categorySlug" element={<CategoryPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/categories"
            element={
              <PrivateRoute>
                <AdminCategories />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/subcategories"
            element={
              <PrivateRoute>
                <AdminSubcategories />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/tags"
            element={
              <PrivateRoute>
                <AdminTags />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/cities"
            element={
              <PrivateRoute>
                <AdminCities />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/businesses"
            element={
              <PrivateRoute>
                <AdminBusinesses />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/requests"
            element={
              <PrivateRoute>
                <AdminRequests />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/reviews"
            element={
              <PrivateRoute>
                <AdminReviews />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/reports"
            element={
              <PrivateRoute>
                <AdminReports />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <PrivateRoute>
                <AdminUsers />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/content-categories"
            element={
              <PrivateRoute>
                <AdminContentCategories />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/content-tags"
            element={
              <PrivateRoute>
                <AdminContentTags />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/blogs"
            element={
              <PrivateRoute>
                <AdminBlogs />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/news"
            element={
              <PrivateRoute>
                <AdminNews />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/blood-donors"
            element={
              <PrivateRoute>
                <AdminBloodDonors />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/phone-logs"
            element={
              <PrivateRoute>
                <AdminPhoneLogs />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/officers"
            element={
              <PrivateRoute>
                <AdminOfficers />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/bhavi-sarpanch"
            element={
              <PrivateRoute>
                <AdminBhaviSarpanch />
              </PrivateRoute>
            }
          />
        </Routes>
      </main>
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <BottomNav onAddClick={openModal} />}
      <SubmitBusinessModal isOpen={isOpen} onClose={closeModal} />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <AdminEditProvider>
        <SubmitBusinessProvider>
          <Router>
            <ScrollToTop />
            <AppContent />
          </Router>
        </SubmitBusinessProvider>
      </AdminEditProvider>
    </HelmetProvider>
  );
}

export default App;
